import React, { PureComponent } from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';

const ICD_10_CM_CODES_QUERY = gql`
  query Icd10CmCodes(
    $searchString: String
    $limit: Int
    $lastId: ID
    $inCodes: [String!]
    $ninCodes: [String!]
  ) {
    icd10CmCodes(
      searchString: $searchString
      limit: $limit
      lastId: $lastId
      inCodes: $inCodes
      ninCodes: $ninCodes
      h: V
    ) {
      nodes {
        id
        code
        mediumDescription
        h
      }
      totalCount
    }
  }
`;

export default Comp => {
  @withApollo
  class WithIcd10CmCodes extends PureComponent {
    static propTypes = {
      client: PropTypes.object.isRequired,
    };

    handleGetIcd10CmCodes = async variables => {
      const { client } = this.props;
      const { data } = await client.query({
        query: ICD_10_CM_CODES_QUERY,
        variables,
      });

      return data.icd10CmCodes;
    };

    render() {
      return <Comp {...this.props} onGetIcd10CmCodes={this.handleGetIcd10CmCodes} />;
    }
  }

  return WithIcd10CmCodes;
};
